import React, { useEffect } from "react";
import { Box, Modal } from "@mui/material";
import Close from "../../Components/Icons/Close";
import { makeStyles } from "@mui/styles";
import cssClasses from "./AgreementOPTConfim.module.css";
import { useState } from "react";
import Button from "../../Subcomponents/Button";
import CountdownTimer from "../../Subcomponents/CountDownTimer";
import CryptoJS from "crypto-js";
import { errorTost } from "../../Services/Toast";
import { useSelector } from "react-redux";
import { sendOTPMessage } from "../../Services/SmsService";

const useStyles = makeStyles((theme) => ({
	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "1.2rem",
		top: "1.2rem",
	},
}));
const AgreementOPTConfim = ({ open, handleClose, confirm }) => {
	let loggedInUser = useSelector((state) => state.Auth.user);
	const [state, setState] = useState({
		otp1: "",
		otp2: "",
		otp3: "",
		otp4: "",
	});
	const [recievedOtp, setRecievedOtp] = useState(null);
	const [resendButton, setResendButton] = useState(false);
	const [showTimer, setShowTimer] = useState(false);
	const [helperText, setHelperText] = useState("");

	const classes = useStyles();

	useEffect(() => {
		smsApiCall();
	}, []);
	function closeModal() {
		handleClose();
	}
	// function smsApiCall() {
	// 	setResendButton(false);
	// 	setState((pre) => {
	// 		pre.otp1 = "";
	// 		pre.otp2 = "";
	// 		pre.otp3 = "";
	// 		pre.otp4 = "";
	// 		return { ...pre };
	// 	});
	// 	let body = {
	// 		number: loggedInUser?.personId?.contactNumber,
	// 		email: loggedInUser?.personId?.email,
	// 	};
	// 	console.log(body);
	// 	sendOTPMessage(body)
	// 		.then((resp) => {
	// 			setShowTimer(true);
	// 			if (resp.data.success) {
	// 				var bytes = CryptoJS.AES.decrypt(resp.data.otp, process.env.REACT_APP_CRYPTO_SECRET_KEY);
	// 				var originalText = bytes.toString(CryptoJS.enc.Utf8);
	// 				// console.log("Otp", parseInt(originalText));
	// 				setRecievedOtp(parseInt(originalText));
	// 				// 900000 ;15 min
	// 				const myTimeout = setTimeout(smsTimeOut, 900000);
	// 			} else {
	// 				if (resp?.data?.error?.ErrorMessage) {
	// 					errorTost(resp?.data?.error?.ErrorMessage);
	// 				} else {
	// 					errorTost("Something went wrong");
	// 				}
	// 			}
	// 		})
	// 		.catch((err) => {
	// 			console.log(err);
	// 			console.log(err.message);
	// 		});
	// }
	function smsApiCall(contactNo, email, isInterNational = false) {
  setResendButton(false);
  setState((pre) => ({
    ...pre,
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
  }));

  // Build body with passed params or fallback to loggedInUser
  let body = {
    number: contactNo || loggedInUser?.personId?.contactNumber,
    email: email || loggedInUser?.personId?.email,
    isInterNational: isInterNational,  // ✅ important!
  };

  sendOTPMessage(body)
    .then((resp) => {
    //   console.log("Full Response:", resp);
      setShowTimer(true);

      if (resp.data) {
        if (resp.data.otp) {
        //   console.log("📦 Received safeEncrypted (base64):", resp.data.otp);

          try {
            const encrypted = atob(resp.data.otp); // decode base64
            const bytes = CryptoJS.AES.decrypt(
              encrypted,
              process.env.REACT_APP_CRYPTO_SECRET_KEY
            );
            const originalText = bytes.toString(CryptoJS.enc.Utf8);

            if (!originalText) {
              errorTost("OTP decryption failed, please try again.");
              return;
            }

            // console.log("🔑 Decrypted OTP:", originalText);
            setRecievedOtp(parseInt(originalText));
            setTimeout(smsTimeOut, 900000); // 15 min timeout
          } catch (err) {
            console.error("❌ Error while decrypting:", err);
            errorTost("Unable to process OTP.");
          }
        } else {
          console.warn("⚠️ Backend did not send encrypted OTP field.");
        }
      } else {
        errorTost(
          resp?.data?.error?.ErrorMessage || "Something went wrong"
        );
      }
    })
    .catch((err) => {
      console.error("sendOTPMessage error:", err);
    });
}


	function smsTimeOut() {
		setHelperText("Otp has expired.Please resend otp!");
		setState((pre) => {
			pre.otp1 = "";
			pre.otp2 = "";
			pre.otp3 = "";
			pre.otp4 = "";
			return { ...pre };
		});
		setRecievedOtp(null);
		setResendButton(true);
	}

	function confirmedOTP() {
		let finalValue = state.otp1 + state.otp2 + state.otp3 + state.otp4;
		console.log(finalValue, "recievedOtp", recievedOtp);
		if (finalValue == recievedOtp) {
			setHelperText("");
			confirm("confirmed");
		} else {
			setState((pre) => {
				pre.otp1 = "";
				pre.otp2 = "";
				pre.otp3 = "";
				pre.otp4 = "";
				return { ...pre };
			});
			errorTost("OTP Doesnt Match.Please Enter Valid OTP");
		}
	}
	function optChange(value1, event) {
		console.log(value1, event);
		event.preventDefault();
		if (event.target.value.length <= 1) {
			setState((pre) => {
				pre[value1] = event.target.value;
				return Object.assign({}, pre);
			});
		}
	}

	const inputfocus = (elmnt) => {
		console.log(elmnt);
		if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
			// const next = elmnt.target.tabIndex - 2;
			// if (next > -1) {
			// 	// elmnt.target.form.elements[next].focus();
			// 	if (elmnt.target.nextSibling) elmnt.target.nextSibling.focus();
			// }
		} else {
			const next = parseInt(elmnt.target.id.split("-")[1]) + 1;
			if (next < 5) {
				if (elmnt.target.nextSibling) elmnt.target.nextSibling.focus();
			}
		}
	};
	return (
		<Modal
			open={open}
			onClose={(_, reason) => {
				if (reason !== "backdropClick") {
					handleClose();
				}
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			sx={[
				{
					".MuiBackdrop-root": {
						background: "rgba(52, 64, 84, 0.7)",
					},
				},
			]}
			disableAutoFocus={true}
		>
			<Box className={cssClasses.modalWrapper}>
				<div className={cssClasses.wrapperHeader}>
					<span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
						<Close width={"1.2rem"} height={"1.2rem"} />
					</span>
					<div> Please enter the 4 digit code To confirm the agreement </div>
				</div>
				<div className={cssClasses.wrapperContent}>
					<div className={cssClasses.otpContainer}>
						<div>
							<input
								className={cssClasses.otpInput}
								name="otp1"
								type="number"
								autoComplete="off"
								value={state.otp1}
								onChange={(e) => optChange("otp1", e)}
								tabIndex="1"
								maxLength="1"
								onKeyUp={(e) => inputfocus(e)}
								id="opt-0"
								inputMode="numeric"
								pattern="[0-9]*"
							/>
							<input
								name="otp2"
								type="number"
								autoComplete="off"
								className={cssClasses.otpInput}
								value={state.otp2}
								onChange={(e) => optChange("otp2", e)}
								tabIndex="2"
								maxLength="1"
								onKeyUp={(e) => inputfocus(e)}
								id="opt-1"
								inputMode="numeric"
								pattern="[0-9]*"
							/>
							<input
								name="otp3"
								type="number"
								autoComplete="off"
								className={cssClasses.otpInput}
								value={state.otp3}
								onChange={(e) => optChange("otp3", e)}
								tabIndex="3"
								maxLength="1"
								onKeyUp={(e) => inputfocus(e)}
								id="opt-2"
								inputMode="numeric"
								pattern="[0-9]*"
							/>
							<input
								name="otp4"
								type="number"
								autoComplete="off"
								className={cssClasses.otpInput}
								value={state.otp4}
								onChange={(e) => optChange("otp4", e)}
								tabIndex="4"
								maxLength="1"
								onKeyUp={(e) => inputfocus(e)}
								id="opt-3"
								inputMode="numeric"
								pattern="[0-9]*"
							/>
						</div>
						<p
							style={{
								color: "red",
								fontSize: "1.4rem",
								lineHeight: "1.66",
							}}
						>
							{helperText}
						</p>
						<div className={cssClasses.resendWrap}>
							{resendButton && (
								<div
									className={cssClasses.verifyOtp}
									onClick={() => {
										setHelperText("");
										smsApiCall();
									}}
								>
									Resend Otp
								</div>
							)}
							{showTimer && (
								<div className={cssClasses.resendOtp}>
									OTP timeout in {/* <Countdown date={startDate.current + 180000} renderer={renderer} /> */}
									<CountdownTimer
										startFrom={180}
										onComplete={() => {
											setShowTimer(false);
											setResendButton(true);
											setRecievedOtp(null);
										}}
										timeFormatter={(time) => {
											return (
												<span>
													{`0${Math.floor(time / 60)}`.slice(-2)}:{`0${time % 60}`.slice(-2)}
												</span>
											);
										}}
									/>
								</div>
							)}
						</div>
					</div>
				</div>
				<div className={cssClasses.wrapperFooter}>
					<div>
						<Button
							style={{
								color: "#fff",
								backgroundColor: "#1570EF",
								fontSize: "1.6rem",
								lineHeight: "2.4rem",
							}}
							btnName={"Submit OTP"}
							clicked={() => {
								confirmedOTP();
							}}
						/>
					</div>
				</div>
			</Box>
		</Modal>
	);
};

export default AgreementOPTConfim;
